module.exports = __webpack_public_path__ + "img/5.94c72c9a.png";